import { defineRoute } from './define-route';

export const routes = [
  // --- Public Pages ---
  defineRoute({
    name: 'home',
    sitemap: 'base',
    internalRoute: '/',
    routes: {
      en: '/',
      sv: '/',
      da: '/',
      no: '/',
      fi: '/',
    },
  }),

  defineRoute({
    name: 'buying-a-pet',
    sitemap: 'base',
    internalRoute: '/buying-a-pet',
    routes: {
      en: '/buying-a-pet',
      sv: '/kopa-husdjur',
      da: '/koeb-kaeledyr',
      no: '/kjop-husdyr',
      fi: '/osta-lemmikki',
    },
  }),

  defineRoute({
    name: 'buying-a-dog',
    sitemap: 'base',
    internalRoute: '/buying-a-dog',
    routes: {
      en: '/buying-a-dog',
      sv: '/kopa-hund',
      da: '/koeb-hund',
      no: '/kjop-hund',
      fi: '/osta-koira',
    },
  }),

  defineRoute({
    name: 'buying-a-cat',
    sitemap: 'base',
    internalRoute: '/buying-a-cat',
    routes: {
      en: '/buying-a-cat',
      sv: '/kopa-katt',
      da: '/koeb-kat',
      no: '/kjop-katt',
      fi: '/osta-kissa',
    },
  }),

  defineRoute({
    name: 'selling-a-pet',
    sitemap: 'base',
    internalRoute: '/selling-a-pet',
    routes: {
      en: '/selling-a-pet',
      sv: '/salja-husdjur',
      da: '/saelg-kaeledyr',
      no: '/salg-husdyr',
      fi: '/myy-lemmikki',
    },
  }),

  defineRoute({
    name: 'selling-a-cat',
    sitemap: 'base',
    internalRoute: '/selling-a-cat',
    routes: {
      en: '/selling-a-cat',
      sv: '/salja-katt',
      da: '/saelg-kat',
      no: '/selge-katt',
      fi: '/myy-kissa',
    },
  }),

  defineRoute({
    name: 'selling-a-dog',
    sitemap: 'base',
    internalRoute: '/selling-a-dog',
    routes: {
      en: '/selling-a-dog',
      sv: '/salja-hund',
      da: '/saelg-hund',
      no: '/selge-hund',
      fi: '/myy-koira',
    },
  }),

  defineRoute({
    name: 'pet-insurance',
    sitemap: 'base',
    internalRoute: '/pet-insurance',
    routes: {
      en: '/pet-insurance',
      sv: '/husdjursforsakring',
      da: '/kaeledyrsforsikring',
      no: '/husdyrforsikring',
      fi: '/elainvakuutus',
    },
  }),

  defineRoute({
    name: 'litter-insurance',
    sitemap: 'base',
    internalRoute: '/litter-insurance',
    routes: {
      en: '/litter-insurance',
      sv: '/kullforsakring',
      da: '/kuldforsikring',
      no: '/kullforsikring',
      fi: '/pentuevakuutus',
    },
  }),

  defineRoute({
    name: 'breeder-tools',
    sitemap: 'base',
    internalRoute: '/breeders/tools',
    routes: {
      en: '/breeders/tools-for-breeders',
      sv: '/uppfodare/verktyg-for-uppfodare',
      da: '/opdraettere/vaerktoejer-for-opdraettere',
      no: '/oppdrettere/verktoy-for-oppdrettere',
      fi: '/kasvattajat/tyokalut-kasvattajille',
    },
  }),

  defineRoute({
    name: 'testimonials',
    sitemap: 'base',
    internalRoute: '/testimonials',
    routes: {
      en: '/testimonials',
      sv: '/omdomen',
      da: '/kundeudtalelser',
      no: '/kundeberettelser',
      fi: '/arviot',
    },
  }),

  defineRoute({
    name: 'about',
    sitemap: 'base',
    internalRoute: '/about-us',
    routes: {
      en: '/about-us',
      sv: '/om-oss',
      da: '/om-os',
      no: '/om-oss',
      fi: '/meista',
    },
  }),

  defineRoute({
    name: 'pet-names.dog',
    sitemap: 'base',
    internalRoute: '/pet-names/dog',
    routes: {
      en: '/dog-names',
      sv: '/hundnamn',
      da: '/hundenavne',
      no: '/hundenavn',
      fi: '/koiran-nimet',
    },
  }),

  defineRoute({
    name: 'pet-names.dog.female',
    sitemap: 'base',
    internalRoute: '/pet-names/dog/female',
    routes: {
      en: '/dog-names/female',
      sv: '/hundnamn/tik',
      da: '/hundenavne/taeve',
      no: '/hundenavn/tispe',
      fi: '/koiran-nimet/narttu',
    },
  }),

  defineRoute({
    name: 'pet-names.dog.male',
    sitemap: 'base',
    internalRoute: '/pet-names/dog/male',
    routes: {
      en: '/dog-names/male',
      sv: '/hundnamn/hane',
      da: '/hundenavne/han',
      no: '/hundenavn/hann',
      fi: '/koiran-nimet/uros',
    },
  }),

  defineRoute({
    name: 'pet-names.cat',
    sitemap: 'base',
    internalRoute: '/pet-names/cat',
    routes: {
      en: '/cat-names',
      sv: '/kattnamn',
      da: '/kattenavne',
      no: '/kattenavn',
      fi: '/kissan-nimet',
    },
  }),

  defineRoute({
    name: 'pet-names.cat.female',
    sitemap: 'base',
    internalRoute: '/pet-names/cat/female',
    routes: {
      en: '/cat-names/female',
      sv: '/kattnamn/hona',
      da: '/kattenavne/hun',
      no: '/kattenavn/hunn',
      fi: '/kissan-nimet/naaras',
    },
  }),

  defineRoute({
    name: 'pet-names.cat.male',
    sitemap: 'base',
    internalRoute: '/pet-names/cat/male',
    routes: {
      en: '/cat-names/male',
      sv: '/kattnamn/hane',
      da: '/kattenavne/han',
      no: '/kattenavn/hann',
      fi: '/kissan-nimet/uros',
    },
  }),

  defineRoute({
    name: 'dog-years',
    sitemap: 'base',
    internalRoute: '/dog-years',
    routes: {
      en: '/dog-years-to-human-years',
      sv: '/hundar-till-manniskoar',
      da: '/hundeaar-til-menneskeaar',
      no: '/hundeaar-til-menneskeaar',
      fi: '/koiran-ika-ihmisvuosina',
    },
  }),

  defineRoute({
    name: 'dog-licence',
    sitemap: 'base',
    internalRoute: '/dog-licence',
    routes: {
      en: '/dog-owner-licence',
      sv: '/hundkorkortet',
      da: '/hundekoerekortet',
      no: '/hundelappen',
      fi: '/koirakortti',
    },
  }),

  defineRoute({
    name: 'dog-licence.module',
    internalRoute: '/dog-licence/[module]',
    routes: {
      en: '/dog-owner-licence/[module]',
      sv: '/hundkorkortet/[module]',
      da: '/hundekoerekortet/[module]',
      no: '/hundelappen/[module]',
      fi: '/koirakortti/[module]',
    },
  }),

  defineRoute({
    name: 'pet-costs.dog',
    sitemap: 'base',
    internalRoute: '/pet-costs/dog',
    routes: {
      en: '/how-much-does-a-dog-cost',
      sv: '/vad-kostar-en-hund',
      da: '/hvad-koster-en-hund',
      no: '/hva-koster-en-hund',
      fi: '/paljonko-koira-maksaa',
    },
  }),

  defineRoute({
    name: 'pet-costs.cat',
    sitemap: 'base',
    internalRoute: '/pet-costs/cat',
    routes: {
      en: '/how-much-does-a-cat-cost',
      sv: '/vad-kostar-en-katt',
      da: '/hvad-koster-en-kat',
      no: '/hva-koster-en-katt',
      fi: '/paljonko-kissa-maksaa',
    },
  }),

  defineRoute({
    name: 'shop.home',
    sitemap: 'base',
    internalRoute: '/shop',
    preserveCurrentTab: true,
    routes: {
      en: '/shop',
      sv: '/butik',
      da: '/butik',
      no: '/butikk',
      fi: '/kauppa',
    },
  }),

  defineRoute({
    name: 'shop.likes',
    internalRoute: '/shop/likes',
    preserveCurrentTab: true,
    routes: {
      en: '/shop/likes',
      sv: '/butik/sparade',
      da: '/butik/gemte',
      no: '/butikk/lagrede',
      fi: '/kauppa/tallennetut',
    },
  }),

  defineRoute({
    name: 'shop.categories',
    internalRoute: '/shop/categories',
    preserveCurrentTab: true,
    routes: {
      en: '/shop/categories',
      sv: '/butik/kategorier',
      da: '/butik/kategorier',
      no: '/butikk/kategorier',
      fi: '/kauppa/kategoriat',
    },
  }),

  defineRoute({
    name: 'shop.category',
    sitemap: 'product_categories',
    internalRoute: '/shop/[category]',
    preserveCurrentTab: true,
    routes: {
      en: '/shop/[category]',
      sv: '/butik/[category]',
      da: '/butik/[category]',
      no: '/butikk/[category]',
      fi: '/kauppa/[category]',
    },
  }),

  defineRoute({
    name: 'shop.product',
    sitemap: 'products',
    internalRoute: '/shop/products/[product]',
    preserveCurrentTab: true,
    routes: {
      en: '/shop/products/[product]',
      sv: '/butik/produkter/[product]',
      da: '/butik/produkter/[product]',
      no: '/butikk/produkter/[product]',
      fi: '/kauppa/tuotteet/[product]',
    },
  }),

  defineRoute({
    name: 'shop.checkout',
    internalRoute: '/shop/checkout',
    preserveCurrentTab: true,
    routes: {
      en: '/shop/checkout',
      sv: '/butik/kassa',
      da: '/butik/kasse',
      no: '/butikk/kassa',
      fi: '/kauppa/kassa',
    },
  }),

  defineRoute({
    name: 'shop.order',
    internalRoute: '/shop/checkout/[order]',
    preserveCurrentTab: true,
    routes: {
      en: '/shop/checkout/[order]',
      sv: '/butik/kassa/[order]',
      da: '/butik/kasse/[order]',
      no: '/butikk/kassa/[order]',
      fi: '/kauppa/kassa/[order]',
    },
  }),

  defineRoute({
    name: 'shop.order.payment',
    internalRoute: '/shop/checkout/[order]/payment/[payment]',
    preserveCurrentTab: true,
    routes: {
      en: '/shop/checkout/[order]/payment/[payment]',
      sv: '/butik/kassa/[order]/betalning/[payment]',
      da: '/butik/kasse/[order]/betaling/[payment]',
      no: '/butikk/kassa/[order]/betaling/[payment]',
      fi: '/kauppa/kassa/[order]/maksu/[payment]',
    },
  }),

  // --- Help & Blog ---
  defineRoute({
    name: 'help.index',
    sitemap: 'base',
    internalRoute: '/help',
    preserveCurrentTab: true,
    routes: {
      en: '/help',
      sv: '/hjalp',
      da: '/hjaelp',
      no: '/hjelp',
      fi: '/ohjeet',
    },
  }),

  defineRoute({
    name: 'help.show',
    internalRoute: '/help/[tag]',
    preserveCurrentTab: true,
    routes: {
      en: '/help/[tag]',
      sv: '/hjalp/[tag]',
      da: '/hjaelp/[tag]',
      no: '/hjelp/[tag]',
      fi: '/ohjeet/[tag]',
    },
  }),

  defineRoute({
    name: 'blog.index',
    sitemap: 'base',
    internalRoute: '/blog',
    preserveCurrentTab: true,
    routes: {
      en: '/blog',
      sv: '/blogg',
      da: '/blog',
      no: '/blogg',
      fi: '/blogi',
    },
  }),

  defineRoute({
    name: 'blog.show',
    sitemap: 'posts',
    internalRoute: '/blog/[post]',
    preserveCurrentTab: true,
    routes: {
      en: '/blog/[post]',
      sv: '/blogg/[post]',
      da: '/blog/[post]',
      no: '/blogg/[post]',
      fi: '/blogi/[post]',
    },
  }),

  defineRoute({
    name: 'blog.tags.show',
    sitemap: 'tags',
    internalRoute: '/blog/tags/[tag]',
    preserveCurrentTab: true,
    routes: {
      en: '/blog/tags/[tag]',
      sv: '/blogg/taggar/[tag]',
      da: '/blog/tags/[tag]',
      no: '/blogg/tagger/[tag]',
      fi: '/blogi/aiheet/[tag]',
    },
  }),

  // --- Policies ---
  defineRoute({
    name: 'policies.purchase-terms',
    internalRoute: '/purchase-terms',
    routes: {
      en: '/purchase-terms',
      sv: '/kopvillkor',
      da: '/koebsvilkaar',
      no: '/kjopsvilkar',
      fi: '/ostoehdot',
    },
  }),

  defineRoute({
    name: 'policies.terms',
    internalRoute: '/terms-of-use',
    routes: {
      en: '/terms-of-use',
      sv: '/anvandarvillkor',
      da: '/brugsvilkaar',
      no: '/bruksbetingelser',
      fi: '/kayttoehdot',
    },
  }),

  defineRoute({
    name: 'policies.privacy',
    internalRoute: '/privacy-policy',
    routes: {
      en: '/privacy-policy',
      sv: '/integritetspolicy',
      da: '/privatlivspolitik',
      no: '/personvernerklaring',
      fi: '/tietosuojaseloste',
    },
  }),

  defineRoute({
    name: 'policies.cookies',
    internalRoute: '/cookie-policy',
    routes: {
      en: '/cookie-policy',
      sv: '/cookie-policy',
      da: '/cookiepolitik',
      no: '/cookie-policy',
      fi: '/evastekaytanto',
    },
  }),

  defineRoute({
    name: 'marketing.unsubscribe',
    internalRoute: '/unsubscribe/[user]/[signature]',
    routes: {
      en: '/unsubscribe/[user]/[signature]',
      sv: '/unsubscribe/[user]/[signature]',
      da: '/unsubscribe/[user]/[signature]',
      no: '/unsubscribe/[user]/[signature]',
      fi: '/unsubscribe/[user]/[signature]',
    },
  }),

  // --- Auth ---
  defineRoute({
    name: 'auth.login',
    internalRoute: '/login',
    preserveCurrentTab: true,
    routes: {
      en: '/login',
      sv: '/logga-in',
      da: '/log-ind',
      no: '/logg-inn',
      fi: '/kirjaudu',
    },
  }),

  defineRoute({
    name: 'auth.token',
    internalRoute: '/auth-from-token',
    routes: {
      en: '/auth-from-token',
      sv: '/auth-from-token',
      da: '/auth-from-token',
      no: '/auth-from-token',
      fi: '/auth-from-token',
    },
  }),

  // --- Listings & Breeders (Public) ---
  defineRoute({
    name: 'listings.index',
    sitemap: 'base',
    internalRoute: '/listings',
    routes: {
      en: '/listings',
      sv: '/annonser',
      da: '/annoncer',
      no: '/annonser',
      fi: '/ilmoitukset',
    },
  }),

  defineRoute({
    name: 'listings.dogs',
    sitemap: 'base',
    internalRoute: '/listings/dog',
    preserveCurrentTab: true,
    routes: {
      en: '/listings/dog',
      sv: '/annonser/hund',
      da: '/annoncer/hund',
      no: '/annonser/hund',
      fi: '/ilmoitukset/koira',
    },
  }),

  defineRoute({
    name: 'listings.cats',
    sitemap: 'base',
    internalRoute: '/listings/cat',
    preserveCurrentTab: true,
    routes: {
      en: '/listings/cat',
      sv: '/annonser/katt',
      da: '/annoncer/kat',
      no: '/annonser/katt',
      fi: '/ilmoitukset/kissa',
    },
  }),

  defineRoute({
    name: 'listings.puppies',
    sitemap: 'base',
    internalRoute: '/listings/puppy',
    preserveCurrentTab: true,
    routes: {
      en: '/listings/puppy',
      sv: '/annonser/valp',
      da: '/annoncer/hvalp',
      no: '/annonser/valp',
      fi: '/ilmoitukset/koiranpentu',
    },
  }),

  defineRoute({
    name: 'listings.kittens',
    sitemap: 'base',
    internalRoute: '/listings/kitten',
    preserveCurrentTab: true,
    routes: {
      en: '/listings/kitten',
      sv: '/annonser/kattunge',
      da: '/annoncer/killing',
      no: '/annonser/kattunge',
      fi: '/ilmoitukset/kissanpentu',
    },
  }),

  defineRoute({
    name: 'listings.create',
    internalRoute: '/listings/create',
    routes: {
      en: '/listings/create',
      sv: '/annonser/skapa',
      da: '/annoncer/opret',
      no: '/annonser/opprett',
      fi: '/ilmoitukset/luo',
    },
  }),

  defineRoute({
    name: 'listings.show',
    sitemap: 'listings',
    internalRoute: '/listings/[listing]',
    preserveCurrentTab: true,
    routes: {
      en: '/listings/[listing]',
      sv: '/annonser/[listing]',
      da: '/annoncer/[listing]',
      no: '/annonser/[listing]',
      fi: '/ilmoitukset/[listing]',
    },
  }),

  defineRoute({
    name: 'listings.contact',
    internalRoute: '/listings/[listing]/contact',
    preserveCurrentTab: true,
    routes: {
      en: '/listings/[listing]/contact',
      sv: '/annonser/[listing]/kontakt',
      da: '/annoncer/[listing]/kontakt',
      no: '/annonser/[listing]/kontakt',
      fi: '/ilmoitukset/[listing]/yhteydenotto',
    },
  }),

  defineRoute({
    name: 'listings.contacted',
    internalRoute: '/listings/[listing]/contacted',
    preserveCurrentTab: true,
    routes: {
      en: '/listings/[listing]/contacted',
      sv: '/annonser/[listing]/meddelande-skickat',
      da: '/annoncer/[listing]/besked-sendt',
      no: '/annonser/[listing]/melding-sendt',
      fi: '/ilmoitukset/[listing]/viesti-lahetetty',
    },
  }),

  defineRoute({
    name: 'breeders.index',
    sitemap: 'base',
    internalRoute: '/breeders',
    preserveCurrentTab: true,
    routes: {
      en: '/breeders',
      sv: '/uppfodare',
      da: '/opdraettere',
      no: '/oppdrettere',
      fi: '/kasvattajat',
    },
  }),

  defineRoute({
    name: 'breeders.dogs',
    sitemap: 'base',
    internalRoute: '/breeders/dog',
    preserveCurrentTab: true,
    routes: {
      en: '/breeders/dog',
      sv: '/uppfodare/hund',
      da: '/opdraettere/hund',
      no: '/oppdrettere/hund',
      fi: '/kasvattajat/koira',
    },
  }),

  defineRoute({
    name: 'breeders.cats',
    sitemap: 'base',
    internalRoute: '/breeders/cat',
    preserveCurrentTab: true,
    routes: {
      en: '/breeders/cat',
      sv: '/uppfodare/katt',
      da: '/opdraettere/kat',
      no: '/oppdrettere/katt',
      fi: '/kasvattajat/kissa',
    },
  }),

  defineRoute({
    name: 'breeders.by-city',
    internalRoute: '/breeders/[city]',
    preserveCurrentTab: true,
    routes: {
      en: '/breeders/[city]',
      sv: '/uppfodare/[city]',
      da: '/opdraettere/[city]',
      no: '/oppdrettere/[city]',
      fi: '/kasvattajat/[city]',
    },
  }),

  defineRoute({
    name: 'breeders.show',
    sitemap: 'breeders',
    internalRoute: '/breeders/profile/[breeder]',
    preserveCurrentTab: true,
    routes: {
      en: '/@[breeder]',
      sv: '/@[breeder]',
      da: '/@[breeder]',
      no: '/@[breeder]',
      fi: '/@[breeder]',
    },
  }),

  defineRoute({
    name: 'breeders.show.pets',
    internalRoute: '/breeders/profile/[breeder]/pets',
    preserveCurrentTab: true,
    routes: {
      en: '/@[breeder]/pets',
      sv: '/@[breeder]/husdjur',
      da: '/@[breeder]/kaeledyr',
      no: '/@[breeder]/husdyr',
      fi: '/@[breeder]/lemmikit',
    },
  }),

  defineRoute({
    name: 'breeders.show.litters',
    internalRoute: '/breeders/profile/[breeder]/litters',
    preserveCurrentTab: true,
    routes: {
      en: '/@[breeder]/litters',
      sv: '/@[breeder]/kullar',
      da: '/@[breeder]/kuld',
      no: '/@[breeder]/kull',
      fi: '/@[breeder]/pentueet',
    },
  }),

  defineRoute({
    name: 'breeders.show.photos',
    internalRoute: '/breeders/profile/[breeder]/photos',
    preserveCurrentTab: true,
    routes: {
      en: '/@[breeder]/photos',
      sv: '/@[breeder]/bilder',
      da: '/@[breeder]/billeder',
      no: '/@[breeder]/bilder',
      fi: '/@[breeder]/kuvat',
    },
  }),

  defineRoute({
    name: 'breeders.show.contact',
    internalRoute: '/breeders/profile/[breeder]/contact',
    preserveCurrentTab: true,
    routes: {
      en: '/@[breeder]/contact',
      sv: '/@[breeder]/kontakt',
      da: '/@[breeder]/kontakt',
      no: '/@[breeder]/kontakt',
      fi: '/@[breeder]/yhteystiedot',
    },
  }),

  defineRoute({
    name: 'breeders.contact',
    internalRoute: '/breeders/profile/[breeder]/message',
    preserveCurrentTab: true,
    routes: {
      en: '/@[breeder]/message',
      sv: '/@[breeder]/meddelande',
      da: '/@[breeder]/besked',
      no: '/@[breeder]/melding',
      fi: '/@[breeder]/viesti',
    },
  }),

  // --- Breeds ---
  defineRoute({
    name: 'breeds.index',
    sitemap: 'base',
    internalRoute: '/breeds',
    preserveCurrentTab: true,
    routes: {
      en: '/breeds',
      sv: '/raser',
      da: '/racer',
      no: '/raser',
      fi: '/rodut',
    },
  }),

  defineRoute({
    name: 'breeds.cats',
    sitemap: 'base',
    internalRoute: '/breeds/cat',
    preserveCurrentTab: true,
    routes: {
      en: '/breeds/cat',
      sv: '/raser/katt',
      da: '/racer/kat',
      no: '/raser/katt',
      fi: '/rodut/kissa',
    },
  }),

  defineRoute({
    name: 'breeds.dogs',
    sitemap: 'base',
    internalRoute: '/breeds/dog',
    preserveCurrentTab: true,
    routes: {
      en: '/breeds/dog',
      sv: '/raser/hund',
      da: '/racer/hund',
      no: '/raser/hund',
      fi: '/rodut/koira',
    },
  }),

  defineRoute({
    name: 'breeds.dogs.advisor',
    sitemap: 'base',
    internalRoute: '/breeds/dog/advisor',
    preserveCurrentTab: true,
    routes: {
      en: '/which-dog-breed-suits-me',
      sv: '/vilken-hundras-passar-mig',
      da: '/hvilken-hunderace-passer-mig',
      no: '/hvilken-hunderase-passer-meg',
      fi: '/mika-koirarotu-sopii-minulle',
    },
  }),

  defineRoute({
    name: 'breeds.dogs.advisor.result',
    internalRoute: '/breeds/dog/advisor/[breedMatch]',
    preserveCurrentTab: true,
    routes: {
      en: '/which-dog-breed-suits-me/[breedMatch]',
      sv: '/vilken-hundras-passar-mig/[breedMatch]',
      da: '/hvilken-hunderace-passer-mig/[breedMatch]',
      no: '/hvilken-hunderase-passer-meg/[breedMatch]',
      fi: '/mika-koirarotu-sopii-minulle/[breedMatch]',
    },
  }),

  defineRoute({
    name: 'breeds.dogs.advisor.share',
    internalRoute: '/breeds/dog/advisor/share/[share]',
    preserveCurrentTab: true,
    routes: {
      en: '/which-dog-breed-suits-me/shared/[share]',
      sv: '/vilken-hundras-passar-mig/delat/[share]',
      da: '/hvilken-hunderace-passer-mig/delt/[share]',
      no: '/hvilken-hunderase-passer-meg/delt/[share]',
      fi: '/mika-koirarotu-sopii-minulle/jaettu/[share]',
    },
  }),

  defineRoute({
    name: 'breeds.dogs.small',
    sitemap: 'base',
    internalRoute: '/breeds/dog/small-dog-breeds',
    preserveCurrentTab: true,
    routes: {
      en: '/breeds/dog/small-dog-breeds',
      sv: '/raser/hund/sma-hundraser',
      da: '/racer/hund/smaa-hunderacer',
      no: '/raser/hund/sma-hunderaser',
      fi: '/rodut/koira/pienet-koirarodut',
    },
  }),

  defineRoute({
    name: 'breeds.dogs.medium',
    sitemap: 'base',
    internalRoute: '/breeds/dog/medium-dog-breeds',
    preserveCurrentTab: true,
    routes: {
      en: '/breeds/dog/medium-dog-breeds',
      sv: '/raser/hund/mellanstora-hundraser',
      da: '/racer/hund/mellemstore-hunderacer',
      no: '/raser/hund/mellomstore-hunderaser',
      fi: '/rodut/koira/keskikokoiset-koirarodut',
    },
  }),

  defineRoute({
    name: 'breeds.dogs.large',
    sitemap: 'base',
    internalRoute: '/breeds/dog/large-dog-breeds',
    preserveCurrentTab: true,
    routes: {
      en: '/breeds/dog/large-dog-breeds',
      sv: '/raser/hund/stora-hundraser',
      da: '/racer/hund/store-hunderacer',
      no: '/raser/hund/store-hunderaser',
      fi: '/rodut/koira/suuret-koirarodut',
    },
  }),

  defineRoute({
    name: 'breeds.show.breeders',
    sitemap: 'breeds',
    internalRoute: '/breeds/[breed]/breeders',
    preserveCurrentTab: true,
    routes: {
      en: '/breeds/[breed]/breeders',
      sv: '/raser/[breed]/uppfodare',
      da: '/racer/[breed]/opdraettere',
      no: '/raser/[breed]/oppdrettere',
      fi: '/rodut/[breed]/kasvattajat',
    },
  }),

  defineRoute({
    name: 'breeds.show.listings',
    sitemap: 'breeds',
    internalRoute: {
      path: '/listings',
      currentPath: null,
      buildQuery: (params, locale) => {
        const breed = params?.breed;

        if (!breed) {
          return {};
        }

        return {
          breeds: typeof breed === 'object' && breed !== null ? breed[locale] : breed,
        };
      },
    },
    preserveCurrentTab: true,
    routes: {
      en: '/breeds/[breed]/listings',
      sv: '/raser/[breed]/annonser',
      da: '/racer/[breed]/annoncer',
      no: '/raser/[breed]/annonser',
      fi: '/rodut/[breed]/ilmoitukset',
    },
  }),

  defineRoute({
    name: 'breeds.show.listings.by-city',
    internalRoute: '/breeds/[breed]/listings/[city]',
    preserveCurrentTab: true,
    routes: {
      en: '/breeds/[breed]/listings/[city]',
      sv: '/raser/[breed]/annonser/[city]',
      da: '/racer/[breed]/annoncer/[city]',
      no: '/raser/[breed]/annonser/[city]',
      fi: '/rodut/[breed]/ilmoitukset/[city]',
    },
  }),

  defineRoute({
    name: 'breeds.show',
    sitemap: 'breeds',
    internalRoute: '/breeds/[breed]',
    preserveCurrentTab: true,
    routes: {
      en: '/breeds/[breed]',
      sv: '/raser/[breed]',
      da: '/racer/[breed]',
      no: '/raser/[breed]',
      fi: '/rodut/[breed]',
    },
  }),

  defineRoute({
    name: 'breeds.show.compare',
    internalRoute: '/breeds/[breed]/vs',
    preserveCurrentTab: true,
    routes: {
      en: '/breeds/[breed]/vs',
      sv: '/raser/[breed]/vs',
      da: '/racer/[breed]/vs',
      no: '/raser/[breed]/vs',
      fi: '/rodut/[breed]/vs',
    },
  }),

  defineRoute({
    name: 'breeds.show.compare.show',
    internalRoute: '/breeds/[breed]/vs/[comparable]',
    preserveCurrentTab: true,
    routes: {
      en: '/breeds/[breed]/vs/[comparable]',
      sv: '/raser/[breed]/vs/[comparable]',
      da: '/racer/[breed]/vs/[comparable]',
      no: '/raser/[breed]/vs/[comparable]',
      fi: '/rodut/[breed]/vs/[comparable]',
    },
  }),

  // --- My Account ---
  defineRoute({
    name: 'me.index',
    internalRoute: '/me',
    routes: {
      en: '/me',
      sv: '/me',
      da: '/me',
      no: '/me',
      fi: '/me',
    },
  }),

  defineRoute({
    name: 'me.listings.index',
    internalRoute: '/me/listings',
    routes: {
      en: '/me/listings',
      sv: '/me/annonser',
      da: '/me/annoncer',
      no: '/me/annonser',
      fi: '/me/ilmoitukset',
    },
  }),

  defineRoute({
    name: 'me.listings.edit',
    internalRoute: '/me/listings/[listing]/edit',
    routes: {
      en: '/me/listings/[listing]/edit',
      sv: '/me/annonser/[listing]/redigera',
      da: '/me/annoncer/[listing]/rediger',
      no: '/me/annonser/[listing]/rediger',
      fi: '/me/ilmoitukset/[listing]/muokkaa',
    },
  }),

  defineRoute({
    name: 'me.listings.create',
    internalRoute: '/me/listings/[listing]/create',
    routes: {
      en: '/me/listings/[listing]/create',
      sv: '/me/annonser/[listing]/skapa',
      da: '/me/annoncer/[listing]/opret',
      no: '/me/annonser/[listing]/opprett',
      fi: '/me/ilmoitukset/[listing]/luo',
    },
  }),

  defineRoute({
    name: 'me.listings.verify',
    internalRoute: '/me/listings/[listing]/verify',
    routes: {
      en: '/me/listings/[listing]/verify',
      sv: '/me/annonser/[listing]/verifiera',
      da: '/me/annoncer/[listing]/verificer',
      no: '/me/annonser/[listing]/verifiser',
      fi: '/me/ilmoitukset/[listing]/vahvista',
    },
  }),

  defineRoute({
    name: 'me.listings.confirmation',
    internalRoute: '/me/listings/[listing]/confirmation',
    routes: {
      en: '/me/listings/[listing]/confirmation',
      sv: '/me/annonser/[listing]/bekraftelse',
      da: '/me/annoncer/[listing]/bekraeftelse',
      no: '/me/annonser/[listing]/bekreftelse',
      fi: '/me/ilmoitukset/[listing]/vahvistus',
    },
  }),

  defineRoute({
    name: 'me.listings.monitor',
    internalRoute: '/me/listings/[listing]/monitor',
    routes: {
      en: '/me/listings/[listing]/statistics',
      sv: '/me/annonser/[listing]/statistik',
      da: '/me/annoncer/[listing]/statistik',
      no: '/me/annonser/[listing]/statistikk',
      fi: '/me/ilmoitukset/[listing]/tilastot',
    },
  }),

  defineRoute({
    name: 'me.listings.litter-insurance',
    internalRoute: '/me/listings/[listing]/litter-insurance',
    routes: {
      en: '/me/listings/[listing]/litter-insurance',
      sv: '/me/annonser/[listing]/kullforsakring',
      da: '/me/annoncer/[listing]/kuldforsikring',
      no: '/me/annonser/[listing]/kullforsikring',
      fi: '/me/ilmoitukset/[listing]/pentuevakuutus',
    },
  }),

  defineRoute({
    name: 'me.likes',
    internalRoute: '/me/likes',
    routes: {
      en: '/me/likes',
      sv: '/me/sparade',
      da: '/me/gemte',
      no: '/me/lagrede',
      fi: '/me/tallennetut',
    },
  }),

  defineRoute({
    name: 'me.payout-details',
    internalRoute: '/me/payout-details',
    routes: {
      en: '/me/payout-details',
      sv: '/me/utbetalningsdetaljer',
      da: '/me/udbetalingsdetaljer',
      no: '/me/utbetalingsdetaljer',
      fi: '/me/tilitystiedot',
    },
  }),

  defineRoute({
    name: 'me.contact-details',
    internalRoute: '/me/contact-details',
    routes: {
      en: '/me/contact-details',
      sv: '/me/kontaktuppgifter',
      da: '/me/kontaktoplysninger',
      no: '/me/kontaktopplysninger',
      fi: '/me/yhteystiedot',
    },
  }),

  defineRoute({
    name: 'me.profile-picture',
    internalRoute: '/me/profile-picture',
    routes: {
      en: '/me/profile-picture',
      sv: '/me/profilbild',
      da: '/me/profilbillede',
      no: '/me/profilbilde',
      fi: '/me/profiilikuva',
    },
  }),

  defineRoute({
    name: 'me.petpay-transactions',
    internalRoute: '/me/petpay-transactions',
    routes: {
      en: '/me/petpay-transactions',
      sv: '/me/petpay-transaktioner',
      da: '/me/petpay-transaktioner',
      no: '/me/petpay-transaksjoner',
      fi: '/me/petpay-tapahtumat',
    },
  }),

  defineRoute({
    name: 'me.verification',
    internalRoute: '/me/account-verification',
    routes: {
      en: '/me/account-verification',
      sv: '/me/kontoverifiering',
      da: '/me/kontoverificering',
      no: '/me/kontoverifisering',
      fi: '/me/tilin-vahvistus',
    },
  }),

  defineRoute({
    name: 'me.payments.show',
    internalRoute: '/me/payments/[payment]',
    routes: {
      en: '/me/payments/[payment]',
      sv: '/me/betalningar/[payment]',
      da: '/me/betalinger/[payment]',
      no: '/me/betalinger/[payment]',
      fi: '/me/maksut/[payment]',
    },
  }),

  defineRoute({
    name: 'me.receipts.index',
    internalRoute: '/me/receipts',
    routes: {
      en: '/me/receipts',
      sv: '/me/kvitton',
      da: '/me/kvitteringer',
      no: '/me/kvitteringer',
      fi: '/me/kuitit',
    },
  }),

  defineRoute({
    name: 'me.receipts.show',
    internalRoute: '/me/receipts/[payment]',
    routes: {
      en: '/me/receipts/[payment]',
      sv: '/me/kvitton/[payment]',
      da: '/me/kvitteringer/[payment]',
      no: '/me/kvitteringer/[payment]',
      fi: '/me/kuitit/[payment]',
    },
  }),

  defineRoute({
    name: 'me.searches.index',
    internalRoute: '/me/searches',
    routes: {
      en: '/me/searches',
      sv: '/me/sokningar',
      da: '/me/soegninger',
      no: '/me/sok',
      fi: '/me/haut',
    },
  }),

  defineRoute({
    name: 'me.searches.show',
    internalRoute: '/me/searches/[search]',
    routes: {
      en: '/me/searches/[search]',
      sv: '/me/sokningar/[search]',
      da: '/me/soegninger/[search]',
      no: '/me/sok/[search]',
      fi: '/me/haut/[search]',
    },
  }),

  defineRoute({
    name: 'me.inbox',
    internalRoute: '/inbox',
    routes: {
      en: '/inbox',
      sv: '/inkorg',
      da: '/indbakke',
      no: '/innboks',
      fi: '/viestit',
    },
  }),

  defineRoute({
    name: 'me.breeder.index',
    internalRoute: '/me/breeder',
    routes: {
      en: '/me/breeder',
      sv: '/me/uppfodare',
      da: '/me/opdraetter',
      no: '/me/oppdretter',
      fi: '/me/kasvattaja',
    },
  }),

  defineRoute({
    name: 'me.breeder.pets',
    internalRoute: '/me/breeder/pets',
    routes: {
      en: '/me/breeder/pets',
      sv: '/me/uppfodare/djur',
      da: '/me/opdraetter/dyr',
      no: '/me/oppdretter/dyr',
      fi: '/me/kasvattaja/elaimet',
    },
  }),

  defineRoute({
    name: 'me.breeder.litters',
    internalRoute: '/me/breeder/litters',
    routes: {
      en: '/me/breeder/litters',
      sv: '/me/uppfodare/kullar',
      da: '/me/opdraetter/kuld',
      no: '/me/oppdretter/kull',
      fi: '/me/kasvattaja/pentueet',
    },
  }),

  defineRoute({
    name: 'me.breeder.breeds',
    internalRoute: '/me/breeder/breeds',
    routes: {
      en: '/me/breeder/breeds',
      sv: '/me/uppfodare/raser',
      da: '/me/opdraetter/racer',
      no: '/me/oppdretter/raser',
      fi: '/me/kasvattaja/rodut',
    },
  }),

  defineRoute({
    name: 'me.breeder.social-links',
    internalRoute: '/me/breeder/social-links',
    routes: {
      en: '/me/breeder/social-links',
      sv: '/me/uppfodare/sociala-lankar',
      da: '/me/opdraetter/sociale-links',
      no: '/me/oppdretter/sosiale-lenker',
      fi: '/me/kasvattaja/somelinkit',
    },
  }),

  defineRoute({
    name: 'me.breeder.profile-settings',
    internalRoute: '/me/breeder/profile-settings',
    routes: {
      en: '/me/breeder/profile-settings',
      sv: '/me/uppfodare/profilinstallningar',
      da: '/me/opdraetter/profilindstillinger',
      no: '/me/oppdretter/profilinnstillinger',
      fi: '/me/kasvattaja/profiiliasetukset',
    },
  }),

  // --- PetPay ---
  defineRoute({
    name: 'petpay',
    sitemap: 'base',
    internalRoute: '/petpay',
    routes: {
      en: '/petpay',
      sv: '/petpay',
      da: '/petpay',
      no: '/petpay',
      fi: '/petpay',
    },
  }),

  defineRoute({
    name: 'petpay.for-buyers',
    sitemap: 'base',
    internalRoute: '/petpay/for-buyers',
    routes: {
      en: '/petpay/for-buyers',
      sv: '/petpay/for-kopare',
      da: '/petpay/for-koebere',
      no: '/petpay/for-kjopere',
      fi: '/petpay/ostajille',
    },
  }),

  defineRoute({
    name: 'petpay.for-sellers',
    sitemap: 'base',
    internalRoute: '/petpay/for-sellers',
    routes: {
      en: '/petpay/for-sellers',
      sv: '/petpay/for-saljare',
      da: '/petpay/for-saelgere',
      no: '/petpay/for-selgere',
      fi: '/petpay/myyjille',
    },
  }),

  defineRoute({
    name: 'petpay.show',
    internalRoute: '/petpay/[petPurchase]',
    routes: {
      en: '/petpay/[petPurchase]',
      sv: '/petpay/[petPurchase]',
      da: '/petpay/[petPurchase]',
      no: '/petpay/[petPurchase]',
      fi: '/petpay/[petPurchase]',
    },
  }),

  defineRoute({
    name: 'petpay.pickup',
    internalRoute: '/petpay/[petPurchase]/pickup',
    routes: {
      en: '/petpay/[petPurchase]/pickup',
      sv: '/petpay/[petPurchase]/hamtning',
      da: '/petpay/[petPurchase]/afhentning',
      no: '/petpay/[petPurchase]/henting',
      fi: '/petpay/[petPurchase]/nouto',
    },
  }),

  defineRoute({
    name: 'petpay.deposit',
    internalRoute: '/petpay/[petPurchase]/deposit',
    routes: {
      en: '/petpay/[petPurchase]/deposit',
      sv: '/petpay/[petPurchase]/deposition',
      da: '/petpay/[petPurchase]/depositum',
      no: '/petpay/[petPurchase]/depositum',
      fi: '/petpay/[petPurchase]/varausmaksu',
    },
  }),

  defineRoute({
    name: 'petpay.insurance',
    internalRoute: '/petpay/[petPurchase]/insurance',
    routes: {
      en: '/petpay/[petPurchase]/insurance',
      sv: '/petpay/[petPurchase]/forsakring',
      da: '/petpay/[petPurchase]/forsikring',
      no: '/petpay/[petPurchase]/forsikring',
      fi: '/petpay/[petPurchase]/vakuutus',
    },
  }),

  defineRoute({
    name: 'petpay.final-payment',
    internalRoute: '/petpay/[petPurchase]/final-payment',
    routes: {
      en: '/petpay/[petPurchase]/final-payment',
      sv: '/petpay/[petPurchase]/slutbetalning',
      da: '/petpay/[petPurchase]/slutbetaling',
      no: '/petpay/[petPurchase]/sluttbetaling',
      fi: '/petpay/[petPurchase]/loppumaksu',
    },
  }),

  defineRoute({
    name: 'petpay.contract.sign',
    internalRoute: '/petpay/[petPurchase]/contract/sign',
    routes: {
      en: '/petpay/[petPurchase]/contract/sign',
      sv: '/petpay/[petPurchase]/kontrakt/signera',
      da: '/petpay/[petPurchase]/kontrakt/underskriv',
      no: '/petpay/[petPurchase]/kontrakt/signer',
      fi: '/petpay/[petPurchase]/sopimus/allekirjoita',
    },
  }),

  defineRoute({
    name: 'petpay.contract.show',
    internalRoute: '/petpay/[petPurchase]/contract/[contract]',
    routes: {
      en: '/petpay/[petPurchase]/contract/[contract]',
      sv: '/petpay/[petPurchase]/kontrakt/[contract]',
      da: '/petpay/[petPurchase]/kontrakt/[contract]',
      no: '/petpay/[petPurchase]/kontrakt/[contract]',
      fi: '/petpay/[petPurchase]/sopimus/[contract]',
    },
  }),

  defineRoute({
    name: 'petpay.contract.edit',
    internalRoute: '/petpay/[petPurchase]/contract/edit',
    routes: {
      en: '/petpay/[petPurchase]/contract/edit',
      sv: '/petpay/[petPurchase]/kontrakt/redigera',
      da: '/petpay/[petPurchase]/kontrakt/rediger',
      no: '/petpay/[petPurchase]/kontrakt/rediger',
      fi: '/petpay/[petPurchase]/sopimus/muokkaa',
    },
  }),

  defineRoute({
    name: 'migration.type',
    internalRoute: '/migration/[type]',
    routes: {
      en: '/migration/[type]',
      sv: '/migration/[type]',
      da: '/migration/[type]',
      no: '/migration/[type]',
      fi: '/migration/[type]',
    },
  }),

  defineRoute({
    name: 'migration',
    internalRoute: '/migration/[type]/[slug]',
    routes: {
      en: '/migration/[type]/[slug]',
      sv: '/migration/[type]/[slug]',
      da: '/migration/[type]/[slug]',
      no: '/migration/[type]/[slug]',
      fi: '/migration/[type]/[slug]',
    },
  }),
] as const;
